var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbDownCurvedFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8836 21.952C11.32 22.0578 11.7513 21.7996 11.9244 21.3853C13.0017 17.4999 16.0017 15.4449 16.0017 12.73V6.2747C16.0017 5.12827 15.3381 3.99944 14.1661 3.57267C11.5152 2.60738 9.76815 2.41096 7.04211 2.6472C4.95127 2.8284 3.37955 4.43145 2.94397 6.36736L2.09922 10.1218C1.53654 12.6226 3.43833 14.9998 6.00166 14.9998L9.00166 14.9999C8.53238 17.8156 7.38664 21.104 10.8836 21.952Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 12.5C22.002 13.6046 21.1065 14.5 20.002 14.5H19.002C17.8974 14.5 17.002 13.6046 17.002 12.5V5.5C17.002 4.39543 17.8974 3.5 19.002 3.5H20.002C21.1065 3.5 22.002 4.39543 22.002 5.5V12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownCurvedFilled);
export default __webpack_public_path__ + "static/media/thumb-down-curved-filled.d1f965bc8a76c1cbab8d1c26e3192d1f.svg";
export { ForwardRef as ReactComponent };